require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-institutions.json") })
        }
      }, "path---ar-eg-institutions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-institutions!./.cache/json/ar-eg-institutions.json
// module id = 438
// module chunks = 231608221292675